import React from 'react';
import { withStyles, Grid, CircularProgress } from '@material-ui/core';
import { withRouter } from "react-router-dom"
import AppUtils from '../../control/apputlis';
import Apis from '../../network/Apis';
import { NewsItem } from './view';
import { ListView } from 'antd-mobile';


class HomeNews extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            newsList: [],
            isRequire: false,
            pageSize: 20,
            pageNum: 1,
            totalPage: 0,
        }
    }


    componentDidMount() {
        AppUtils.YMPush('MAIN', 'HomeNews');
        this.getNewsList(true);
    }

    componentWillUnmount() {
        this.setState = () => false;
    }

    getNewsList = async (isRequire = false) => {
        const { pageSize, pageNum, newsList } = this.state;
        this.setState({ isRequire: isRequire });
        let result = await Apis.encryptionQiutxNews(pageSize, pageNum);
        console.log('getNewsList', result);
        if (result.code == 200) {
            if (result.data && result.data.list) {

                result.data.list.forEach(element => {
                    let exist = false;
                    newsList.forEach(ele => {
                        if (element.id == ele.id) {
                            exist = true;
                        }
                    })
                    if (!exist) {
                        newsList.push(element);
                    }
                });
                this.setState({ newsList: newsList, totalPage: result.data.totalPage });
            }
        }
        this.setState({ isRequire: false });
    }

    _onEndReached = () => {
        const { pageNum, totalPage } = this.state;
        let pageNow = pageNum + 1;

        console.log('_onEndReached', pageNow, totalPage);

        if (pageNow < totalPage) {
            this.setState({ pageNum: pageNow }, () => {
                this.getNewsList();
            })
        }
    }

    _renderHeader = () => {
        return (<Grid style={{ height: 12 }}></Grid>);
    }

    _renderItem = (data) => {
        return (
            <Grid container justify='flex-start' direction='row' alignItems='center' style={{ width: '100vw' }}>
                {
                    data.map((item, n) => (
                        <Grid key={n} container alignItems='center' style={{ maxWidth: '50vw', paddingLeft: 8, marginBottom: 16 }}>
                            <NewsItem data={item}></NewsItem>
                        </Grid>
                    ))
                }
            </Grid>
        );
    }

    _renderFooter = () => {
        return (<Grid style={{ height: 48 }}></Grid>);
    }

    render() {
        const { classes } = this.props;
        const { newsList, isRequire } = this.state;
        let data = AppUtils.processList(newsList, 2);
        const ds = new ListView.DataSource({
            rowHasChanged: (r1, r2) => r1 !== r2
        });

        if (!isRequire) {
            return <div className={classes.list}>
                <ListView
                    initialListSize={data.length}
                    style={{ width: '100%', maxWidth: '100%', height: '100%' }}
                    contentContainerStyle={{ width: '100%' }}
                    dataSource={ds.cloneWithRows(data)}
                    renderHeader={this._renderHeader}
                    renderFooter={this._renderFooter}
                    renderRow={this._renderItem}
                    onEndReached={this._onEndReached}
                    pageSize={6}
                    useBodyScroll={false}
                    onEndReachedThreshold={0.5}
                />
            </div>
        }
        return <div style={{ width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }} >
            <CircularProgress color='secondary' size={20} />
        </div>;

    }

}

export default withRouter(withStyles((theme) => ({
    list: {
        margin: theme.spacing(0),
        padding: theme.spacing(0),
        height: '100%',
    },
}))(HomeNews));